// @ts-strict-ignore
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { l } from "@shared/locales/i18n";

const useCatalogSearchResultTitle = (
  query: string,
  displayCount: number,
  totalCount: number
): ReactElement[] => {
  const { t } = useTranslation();

  const showingText = <span key="showing">{t(l.sharedCommon.CatalogSearchTitleShowing)}</span>;
  const outOfText = <span key="outOf">{t(l.sharedCommon.CatalogSearchTitleOutOf)}</span>;

  const resultText = <span key="result">{t(l.sharedCommon.CatalogSearchTitleResult)}</span>;
  const resultPluralText = <span key="results">{t(l.sharedCommon.CatalogSearchTitleResults)}</span>;

  const space = num => <span key={`space${num}`}> </span>;
  const displayCountText = <b key="displayCount">{displayCount}</b>;
  const totalCountText = <b key="totalCount">{totalCount}</b>;

  if (totalCount === 0) {
    return;
  }

  const prependText = [
    showingText,
    space(0),
    displayCountText,
    space(1),
    outOfText,
    space(2),
    totalCountText,
  ];

  // Singular
  if (totalCount === 1) {
    return [...prependText, space(3), resultText];
  }

  // Plural
  return [...prependText, space(3), resultPluralText];
};

export { useCatalogSearchResultTitle };
